import React from 'react';

import styles from './index.module.scss';
export const AssetGrid = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['asset-grid']} ${className}` : styles['asset-grid']}
    {...props}
  />
);

export const CollaboratorsGrid = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['collaborators-grid']} ${className}` : styles['collaborators-grid']
    }
    {...props}
  />
);
